import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const MARGIN = 200;

class Tabbar {
	constructor(el) {
		this.el = el;
		this.logotype = el?.querySelector('.tabbar__link._logotype');
		this.header = document.querySelector('.header');
		this.categoriesBlock = document.querySelector('[data-categories]');

		if (this.logotype && this.header && this.categoriesBlock) this.initLogotype();
	}

	initLogotype() {
		const minTop = -30;
		const maxTop = 30;

		const quickTop = gsap.quickTo(this.logotype, 'top', { duration: 0.3, ease: 'power2.out' });
		gsap.set(this.logotype, { top: minTop, opacity: 1 });

		const updateTargetTopOnRefresh = () => {
			const isPageScrolled = window.scrollY > 0;
			if (isPageScrolled) {
				gsap.set(this.logotype, { top: maxTop });
				this.el.classList.add('_scrolled');
			} else {
				gsap.set(this.logotype, { top: minTop });
				this.el.classList.remove('_scrolled');
			}
		};

		ScrollTrigger.create({
			trigger: this.header,
			start: 'top top',
			endTrigger: this.categoriesBlock,
			end: `top+=${MARGIN} top`,
			onUpdate: (self) => {
				// Пропорция прогресса от 0 до 1
				const targetTop = minTop + (maxTop - minTop) * self.progress;
				quickTop(targetTop);
			},
			invalidateOnRefresh: true,
			onRefresh: updateTargetTopOnRefresh,
		});
	}
}

document.querySelectorAll('[data-tabbar]').forEach((tabbarEl) => new Tabbar(tabbarEl));
export default Tabbar;
